export default {
    "确认": "確認",
    "取消": "キャンセル",
    "选择语言": "言語を選択",
    "切换语言成功": "言語切り替え成功",
    "首页": "ホーム",
    "申购": "申し込み",
    "团队": "チーム",
    "资金管理": "資金管理",
    "资金明细": "資金明細",
    "我的订单": "自分の注文",
    "订单详情": "注文詳細",
    "交易进行中,请勿进行其他操作": "取引中です。他の操作を行わないでください",
    "没有更多了": "これ以上はありません",
    "加载中": "読み込み中",
    "代币价格": "トークン価格",
    "收益概览": "収益概要",
    "申购收益": "申し込み収益",
    "分享收益": "共有収益",
    "官方网站": "公式ウェブサイト",
    "官网": "公式サイト",
    "电报": "テレグラム",
    "推特": "ツイッター",
    "白皮书": "ホワイトペーパー",
    "申购金额": "申し込み金額",
    "请输入入金金额": "入金金額を入力してください",
    "快捷申购": "クイック申し込み",
    "申购比例": "申し込み割合",
    "赠币数量": "プレゼントトークン数",
    "立即申购": "すぐ申し込む",
    "更多": "もっと",
    "订单": "注文",
    "分红中": "配当受取中",
    "已完成": "完了済み",
    "累计分红": "累計配当",
    "申购信息": "申し込み情報",
    "兑换数量": "交換数量",
    "开始时间": "開始時間",
    "提现成功": "引き出し成功",
    "订单编号": "注文番号",
    "团队数据总览": "チームデータ総覧",
    "我的推广链接": "自分のプロモーションリンク",
    "复制": "コピー",
    "分享此链接邀请好友加入团队，获取推广奖励": "このリンクを共有して友達をチームに誘って、プロモーション報酬を獲得します",
    "团队业绩": "チーム業績",
    "当前等级": "現在のレベル",
    "今日收益": "今日の収益",
    "团队用户": "チームユーザー",
    "有效团队": "有効なチーム",
    "有效用户": "有効なユーザー",
    "无效团队": "無効なチーム",
    "直推用户": "直接推薦ユーザー",
    "有效直推": "有効な直接推薦",
    "无效直推": "無効な直接推薦",
    "资产余额数据概览": "資産残高データ概覧",
    "提现": "引き出し",
    "选中币种": "選択した通貨",
    "提现数量": "引き出し数量",
    "确认提现": "引き出しを確認",
    "分红收入": "配当収入",
    "直推奖励": "直接推薦報酬",
    "团队奖励": "チーム報酬",
    "全部": "全て",
    "收入": "収入",
    "支出": "支出",
    "请输入正确的金额": "正しい金額を入力してください",
    "申购成功": "申し込み成功",
    "申购失败": "申し込み失敗",
    "提现成功": "引き出し成功",
    "提现失败": "引き出し失敗",
    "提现信息": "引き出し情報",
    "提现币种": "引き出し通貨",
    "提现数量": "引き出し数量",
    "请选择币种": "通貨を選択してください",
    "钱包余额不足": "ウォレットの残高が不足しています",
    "余额不足": "残高が不足しています",

    "提现手续费": "引き出し手数料",
    "间推奖励": "間接紹介報酬",
    "团队奖励": "チーム報酬",
    "提现失败退还": "引き出し失敗の返金",
    "ido申购": "IDO 申し込み",
    "ido申购赠送": "IDO 申し込みプレゼント",
    "链式去中心化全球点火网络": "チェーン分散型グローバル点火ネットワーク",
    "长期价值": "長期的な価値",
    "智能涌现": "インテリジェントな出現",
    "协议永生": "プロトコルの永続性",
    "立即进入": "すぐに入る",
    "大区累计业绩": "大区分の累計業績",
    "小区累计业绩": "小区区分の累計業績",
    "复制成功": "コピー成功",
    "复制失败":"コピー失敗",
    "暂无数据": "データがありません",
    "平级奖励": "同レベル報酬",
    "申购金额不能小于":"申し込み金額は未満ではないでください",
}